export const serializeQueryParams = (obj: Record<string, string | number | boolean>) =>
	Object.entries(obj).reduce((ac, [key, val]) => `${ac}&${key}=${val}`, "")
